/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Combo_Component_CycleInputs */

const vi_error_combo_component_cycle = /** @type {(inputs: Error_Combo_Component_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành phần vừa chọn lại chứa chính combo này trong công thức của nó (vòng lặp). Chọn thành phần khác.`)
};

/**

* @param {Error_Combo_Component_CycleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_combo_component_cycle = /** @type {((inputs?: Error_Combo_Component_CycleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Combo_Component_CycleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_combo_component_cycle(inputs)
});